<div class="app-page-title">
    <div class="page-title-wrapper">
        <div class="page-title-heading">
            <div class="page-title-icon">
                <i class="pe-7s-box2 icon-gradient bg-mean-fruit">
                </i>
            </div>
            <div>{{'data.company_contract' | translate}}
                <div class="page-title-subheading">{{'data.add_contract_company' | translate}}
                </div>
            </div>
        </div>
        <div class="page-title-actions">
            <!-- <button type="button" data-toggle="tooltip" title="Example Tooltip" data-placement="bottom"
                class="mr-2 btn-icon btn-icon-only btn btn-primary">
                <i class="pe-7s-id"></i>
                Détails du contrat
            </button> -->

            <button type="button" data-toggle="tooltip" title="Example Tooltip" data-placement="bottom"
                class="mr-2 btn-icon btn-icon-only btn btn-outline-success">
                <i class="pe-7s-download text-success"></i>
                {{'data.download_contract' | translate}}
            </button>
        </div>
    </div>
</div>

<div *ngIf="loading; else elseContractSociety">
    <div class="row">
        <div class="col-md-12">
            <div class="main-card mb-3 card">
                <div class="card-body text-center">
                    <div class="spinner-container blue-spinner">
                        <mat-progress-spinner mode="indeterminate" [diameter]="40"
                            [strokeWidth]="5"></mat-progress-spinner>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #elseContractSociety>

    <div [formGroup]="form">
        <div class="main-card mb-3 card">
            <div class="card-header-tab card-header">
                <div class="card-header-title">
                    <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure"> </i>
                    {{'data.contract_details' | translate}}
                </div>
                <div class="btn-actions-pane-right">
                    <button type="button" (click)="addNewFreightRateGroup()" class="mt-1 btn btn-warning">
                        <i class="pe-7s-plus"></i> {{'data.add' | translate}}
                    </button>
                </div>
            </div>

            <div class="card-body">
                <div class="container">
                    <div formArrayName="freightRates">
                        <div *ngFor="let freightRate of freightRates.controls; let i = index">
                            <div class="position-relative row form-group mb-5" [formGroupName]="i" style="margin-top: 10px;">
                                <div class="col-12">
                                    <div class="row form-group">
                                        <div class="col-12 col-md-8">
                                            <select class="form-control input-border" formControlName="country"
                                                placeholder="Sélectionnez le pays">
                                                <option [ngValue]="null">Sélectionnez le pays</option>
                                                <option [value]="item" *ngFor="let item of countries">
                                                    {{item}}
                                                </option>
                                            </select>
                                            <div class="text-danger mt-1"
                                                *ngIf="freightRate.get('country').touched && freightRate.get('country').invalid">
                                                Le country est requis.
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <button type="button" (click)="deleteFreightRateGroup(i)"
                                                class="mr-2 btn-icon btn-icon-only btn btn-danger float-right">
                                                <i class="pe-7s-trash btn-icon-wrapper"></i>
                                            </button>

                                            <button type="button" (click)="addRanges(i)"
                                                class="mr-2 btn-icon btn-icon-only btn btn-success float-right">
                                                <i class="pe-7s-plus btn-icon-wrapper"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12" formGroupName="minimum" style="margin-top: 20px;">
                                    <div class="row form-group">
                                        <div class="col-12 col-md-2 text-center label-center">
                                            <b>Minimum</b>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <input type="number" class="form-control input-border" placeholder="Maximum"
                                                formControlName="max">
                                            <div class="text-danger mt-1"
                                                *ngIf="freightRate.get('minimum.max').touched && freightRate.get('minimum.max').invalid">
                                                La valeur est requise.
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <input type="number" class="form-control input-border"
                                                placeholder="{{'data.price' | translate}}" formControlName="value">
                                            <div class="text-danger mt-1"
                                                *ngIf="freightRate.get('minimum.value').touched && freightRate.get('minimum.value').invalid">
                                                La valeur est requise.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12" style="margin-top: 10px; ">
                                    <div formArrayName="ranges">
                                        <div *ngFor="let range of getRanges(i).controls; let j = index">
                                            <div class="col-12" [formGroupName]="j" style="margin-bottom: 10px;">
                                                <div class="row form-group">
                                                    <div class="col-12 col-md-1 float-center">
                                                        <!-- <b>{{j+1}}</b> -->
                                                        <button type="button" (click)="deleteRangeGroup(i, j)"
                                                            class="mr-2 btn-icon btn-icon-only btn btn-danger float-right"><i
                                                                class="pe-7s-trash btn-icon-wrapper">
                                                            </i></button>
                                                    </div>
                                                    <div class="col-12 col-md-2">
                                                        <input type="number" class="form-control input-border"
                                                            placeholder="Minimum" formControlName="min">
                                                        <div class="text-danger mt-1"
                                                            *ngIf="range.get('min').touched && range.get('min').invalid">
                                                            La valeur est requise.
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-md-2">
                                                        <input type="number" class="form-control input-border"
                                                            placeholder="Maximum" formControlName="max">
                                                        <div class="text-danger mt-1"
                                                            *ngIf="range.get('max').touched && range.get('max').invalid">
                                                            La valeur est requise.
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-md-2">
                                                        <input type="number" class="form-control input-border"
                                                            placeholder="{{'data.price' | translate}}"
                                                            formControlName="value">
                                                        <div class="text-danger mt-1"
                                                            *ngIf="range.get('value').touched && range.get('value').invalid">
                                                            La valeur est requise.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12" style="margin-bottom: 20px;">
                                    <div class="row form-group">
                                        <div class="col-12 col-md-2 text-center label-center">
                                            <b>{{'data.by_truck' | translate}}</b>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <input type="number" class="form-control input-border" placeholder="Maximum"
                                                formControlName="maximum">
                                            <div class="text-danger mt-1"
                                                *ngIf="freightRate.get('maximum').touched && freightRate.get('maximum').invalid">
                                                Le maximum est requis.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-card mb-3 card">
            <div class="card-header-tab card-header">
                <div class="card-header-title">
                    <i class="header-icon lnr-rocket icon-gradient bg-tempting-azure"> </i>
                    Offers
                </div>
                <div class="btn-actions-pane-right">
                    <button type="button" (click)="addOffer()" class="mt-1 btn btn-warning">
                        <i class="pe-7s-plus"></i> {{'data.add' | translate}}
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="container">
                    <div formArrayName="offers">
                        <div class="form-row align-items-end mb-2 p-2 border rounded"
                            *ngFor="let offerGroup of offersFA.controls; let i = index" [formGroupName]="i">

                            <div class="form-group col-md-2 mb-auto">
                                <legend class="">
                                    Plateforme :
                                </legend>
                                <input type="text" class="form-control" formControlName="plateform"
                                    name="plateform-{{i}}" id="plateform-{{i}}" placeholder="Ex: Livraison express">
                                <div class="text-danger mt-1"
                                    *ngIf="offerGroup.get('plateform').touched && offerGroup.get('plateform').invalid">
                                    Le champ est requis.
                                </div>
                            </div>

                            <div class="form-group col-md-2 mb-auto">
                                <legend class="">
                                    Type de facturation :
                                </legend>
                                <select class="form-control selectric" formControlName="type" name="type-{{i}}"
                                    id="type-{{i}}" (change)="onChangeOfferType($event, i)">
                                    <option [ngValue]="undefined">Select a logistic type</option>
                                    <option value="transport">Transport</option>
                                    <option value="taxes">Taxes</option>
                                </select>
                                <div class="text-danger mt-1"
                                    *ngIf="offerGroup.get('type').touched && offerGroup.get('type').invalid">
                                    Le champ est requis.
                                </div>
                            </div>

                            <div class="form-group col-md-3 mb-auto">
                                <legend class="">
                                    Paramètre de facturation :
                                </legend>

                                <ng-container *ngIf="offerGroup.get('type')?.value === 'taxes'; else elseContractSociety">
                                    <input type="text" class="form-control" formControlName="labels" name="labels-{{i}}"
                                        id="labels-{{i}}" placeholder="Ex: Livraison express">
                                </ng-container>
                                <ng-template #elseContractSociety>
                                    <ng-select
                                        [items]="transportorTypes"
                                        bindLabel="title"
                                        bindValue="label"
                                        [multiple]="true"
                                        formControlName="labels"
                                        [clearable]="true"
                                        [closeOnSelect]="false"
                                        id="labels-{{ i }}"
                                        name="labels-{{ i }}">
                                    </ng-select>
                                </ng-template>

                                <div class="text-danger mt-1"
                                    *ngIf="offerGroup.get('labels').touched && offerGroup.get('labels').invalid">
                                    Le champ est requis.
                                </div>
                            </div>

                            <div class="form-group col-md-3 mb-auto">
                                <legend class="">
                                    Paramètre logistique :
                                </legend>
                                <select class="form-control selectric" formControlName="logistic_param" name="logistic_param"
                                    id="logistic_param">
                                    <option [ngValue]="undefined">Select a logistic param</option>
                                    <option [value]="item" *ngFor="let item of logisticParams">
                                        {{item}}
                                    </option>
                                </select>
                                <div class="text-danger mt-1"
                                    *ngIf="offerGroup.get('logistic_param').touched && offerGroup.get('logistic_param').invalid">
                                    Le champ est requis.
                                </div>
                            </div>

                            <div class="form-group col-md-2 mb-auto">
                                <legend class="">Cout</legend>
                                <input type="number" class="form-control" formControlName="value" min="0"
                                    name="value-{{i}}" id="value-{{i}}" step="0.01" placeholder="0.00">
                                <div class="text-danger mt-1"
                                    *ngIf="offerGroup.get('value').touched && offerGroup.get('value').invalid">
                                    La valeur est requise et doit être ≥ 0.
                                </div>
                            </div>

                            <div class="form-group col-md-3 mb-auto">
                                <legend class="">Min Level</legend>
                                <input type="number" class="form-control" formControlName="min_level" min="0"
                                    name="min_level-{{i}}" id="min_level-{{i}}" step="0.01" placeholder="0.00">
                            </div>

                            <div class="form-group col-md-3 mb-auto">
                                <legend class="">Max Level</legend>
                                <input type="number" class="form-control" formControlName="max_level" min="0"
                                    name="max_level-{{i}}" id="max_level-{{i}}" step="0.01" placeholder="0.00">
                            </div>

                            <div class="form-group col-md-3 mb-auto">
                                <legend class="">Min</legend>
                                <input type="number" class="form-control" formControlName="min" min="0" name="min-{{i}}"
                                    id="min-{{i}}" step="0.01" placeholder="0.00">
                            </div>

                            <div class="form-group col-md-2 mb-auto">
                                <legend class="">Max</legend>
                                <input type="number" class="form-control" formControlName="max" min="0" name="max-{{i}}"
                                    id="max-{{i}}" step="0.01" placeholder="0.00">
                            </div>

                            <div class="form-group col-md-1 text-right mt-auto mb-auto">
                                <button type="button" (click)="removeOffer(i)"
                                    class="mr-2 btn-icon btn-icon-only btn btn-danger float-right">
                                    <i class="pe-7s-trash btn-icon-wrapper"></i>
                                </button>
                            </div>
                        </div>

                        <div class="text-muted text-center" *ngIf="offersFA.length === 0">
                            Aucune offre. Cliquez sur “Ajouter une offre”.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-card mb-3 card">
        <div class="d-block text-center card-footer">
            <button type="submit" (click)="addContractSociety()" class="btn btn-primary btn-lg btn-block">
                {{'data.save_contract' | translate}}</button>
        </div>
    </div>
</ng-template>